var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["MEDIUM"] = 576] = "MEDIUM";
    Breakpoints[Breakpoints["LARGE"] = 1024] = "LARGE";
    Breakpoints[Breakpoints["XLARGE"] = 1280] = "XLARGE";
})(Breakpoints || (Breakpoints = {}));
export default Breakpoints;
